import * as THREE from 'three';
import { matUtils } from '../base';
import { View3dGlobal, ThreeView, ModelInfo } from '.';
import * as marietta from '../..';

import * as modelloader from './loader';
import { SceneExtras } from './sceneExtras';
import { OctreeManager } from './Octree/OctreeManager';

export class ChangeItem {

    private creatModelInfo(object: THREE.Object3D) {
        const model: ModelInfo = new ModelInfo();
        model.setTranslate(object.position.x, object.position.y, object.position.z);
        model.setRotation(object.rotation.x, object.rotation.y, object.rotation.z);
        if (object.scale.x < 0) {
            model.setScale(-1, 1, 1);
        } else {
            model.setScale(1, 1, 1);
        }
        // model.setScale(object.scale.x, object.scale.y, object.scale.z);

        // model.reverse = object.userData.modelInfo.reverse;

        model.layer = object.userData.layer;

        model.type = object.userData.modelInfo.type;
        model.uuid = object.userData.modelInfo.uuid;

        model.typeExtras = object.userData.modelInfo.typeExtras;
        model.subType = object.userData.modelInfo.subType;

        return model;
    }

    private findIndexFromFurnitureObject(obj: THREE.Object3D) {
        return ThreeView.get().wcItemmgr.furnitureObjects.findIndex((object) => {
            return obj.uuid == object.uuid;
        })
    }
    /* changeItem
     * 入替えボタンが押された.
     */
    public changeItem(target: THREE.Object3D, id: string): void {

        // const target = ThreeView.get().wcItemmgr.pickers[n].getTargetObject(); // オリジナル形状.
        // const oldobj = <THREE.Group>(ThreeView.get().wcItemmgr.furnitureObjects[n]); // 現在選択中形状.

        const oldobj = target;
        let selection: number = 0 ;
        for( let i:number = 0; i < oldobj.userData.attribute.alternative.length; i++ ){
            if( id == oldobj.userData.attribute.alternative[i].id ){
                selection = i + 1;
                break;
            }
        }

        const funitureindex = this.findIndexFromFurnitureObject(target);

        let newId = target.userData.attribute.objectId;
        let newName = target.userData.attribute.objectName;
        let newWidth = 0;
        let newHeight = 0;
        if (selection > 0) {
            const alternative = oldobj.userData.attribute.alternative[selection - 1];
            newId = alternative.id;
            newName = alternative.fileName;
            newWidth = alternative.width;
            newHeight = alternative.depth;
        } else {
            const partinfo: any = ThreeView.get().planmgr.autoData.autoPartsInfo(target.userData.attribute.objectId);
            newWidth = partinfo.width;
            newHeight = partinfo.depth;
        }

        const modelinfo = this.creatModelInfo(oldobj);
        modelinfo.url = View3dGlobal.shared.itemDir + newName;
        modelinfo.code = target.userData.attribute.objectId;
        modelinfo.idthreed = newId;
        modelinfo.uuid = target.userData.modelInfo.uuid;

        const onLoad = (object: any) => {

            const itemManager = ThreeView.get().wcItemmgr;
            //floorsObjectsから前の形状を削除して新しい形状を登録する
            const floorsObjects = itemManager.floorsObjects.getObjects('L' + String(ThreeView.get().wcCameras.floor));
            const index = floorsObjects.findIndex((obj: THREE.Object3D) => obj.uuid == oldobj.uuid);
            if ( index != null ) floorsObjects.splice(index, 1);
            itemManager.registFloorObject(object);

            ThreeView.get().matmgr.adjustMaterial(object, ThreeView.get().matmgr.isWhiteModel(object));
            matUtils.turnOffLights(object);

            object.userData.attribute.alternative = oldobj.userData.attribute.alternative;
            object.userData.attribute.thumbnail = oldobj.userData.attribute.thumbnail;

            if (ThreeView.get().wcItemmgr.isAddItem(oldobj)) {
                ThreeView.get().wcItemmgr.removeAddItemShapes(oldobj);
            } else {
                itemManager.scene.remove(target);
                itemManager.scene.remove(oldobj);
            }
            itemManager.furnitureObjects[funitureindex] = object;
            itemManager.scene.add(object);

            ThreeView.get().wcItemmgr.changeHouseData(oldobj, object);
            ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
            // 画角内判定
            ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

            // アイテム選択解除
            ThreeView.get().unSelectedObject();

            if (ThreeView.get().pickermanager.hasPicker()) {
                ThreeView.get().pickermanager.changeTargetObject(object);
            }

            const info = {
                width: newWidth,
                height: newHeight,
                idthreed: modelinfo.idthreed,
                reverse: (oldobj.scale.x < 0),
                isChangeItem: true
            };

            marietta.webcad.WebCADGlobal.change2Dfrom3D(modelinfo.uuid, modelinfo.code, info);

            //sceneextras更新
            new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).update();
        };

        const objLoader = new modelloader.ObjectLoader();
        objLoader.loadASync(modelinfo, oldobj.userData.attribute.alternative)
        .then((object) => {
            onLoad(object);
        })
    }
}
